import React, { useRef, useCallback } from 'react';
import t from '~t';
import { useSelector } from 'react-redux';
import { user as getUser } from '~data/selectors/user';

import { Layout, Text, ButtonRow, Button, Icon } from '~ui';

export default function SharingLink({
  collection: { slug, _id, public: pub },
}) {
  const user = useSelector((state) => getUser(state));
  const link = `https://${user.name}.raindrop.page/${slug || ''}-${_id}`;

  const input = useRef(null);
  const copy = useCallback(() => {
    input.current.select();
    input.current.setSelectionRange(0, 99999);
    input.current.focus();
    document.execCommand('copy');
  }, [input]);

  if (!pub) return null;

  return (
    <Layout>
      <Text ref={input} type='text' readOnly autoFocus value={link}>
        <Button asChild variant='ghost' size='icon'>
          <a href={link} target='_blank' title={t.s('openInBrowser')}>
            <Icon name='open' />
          </a>
        </Button>
      </Text>

      <ButtonRow>
        <Button variant='primary' onClick={copy}>
          <Icon name='duplicates' />
          {t.s('copyURL')}
        </Button>
      </ButtonRow>
    </Layout>
  );
}
